module.exports = __webpack_public_path__ + "media/app/assets/regions/EU-a89eae85eea6214e1b73bbea2dd2837f.png";